<template>
  <form>
    <p>
      {{$t('medium_grant.technical__9_identify_project_milestones')}}
    </p>
    <div class="row">
      <div class="col-lg-12">
        <table class="mt-4" width="100%">
          <thead>
          <th>{{$t('medium_grant.technical__9_milestone')}}</th>
          <th>{{$t('medium_grant.technical__9_milestone_date')}}</th>
          </thead>
          <tbody>
          <tr v-for="(milestone, index) in milestones" :key="index">
            <td width="70%">
              <div class="form-group">
          <textarea
            class="form-control"
                v-model="milestone.name"
                :placeholder="$t('medium_grant.technical__9_milestone')"
              >
          </textarea>
              </div>
            </td>
            <td>
              <base-input
                name="technical.startDate"
                :placeholder="$t('medium_grant.technical__9_milestone_date')"
              >
                <el-date-picker
                  type="date"
                  v-model="milestone.date"
                  :placeholder="$t('medium_grant.technical__9_milestone_date')"
                >
                </el-date-picker>
              </base-input>
            </td>
          </tr>
          </tbody>
          <base-button v-if="milestones.length < maxMilestones" @click="addMilestone" type="primary" class="btn-simple" size="sm">
            + {{$t('general.add_row')}}
          </base-button>
        </table>
      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";
  import {DatePicker} from 'element-ui';

  export default {
    data() {
      return {
        GrantForm,
        milestones: [{}],
        maxMilestones: 20
      }
    },
    components: {
      [DatePicker.name]: DatePicker
    },
    methods: {
      addMilestone() {
        this.milestones.push({});
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    },
    mounted() {
      if (GrantForm.revisionModel.technical.milestones) {
        this.milestones = GrantForm.revisionModel.technical.milestones;
      }
    },
    watch: {
      milestones(value) {
        GrantForm.revisionModel.technical.milestones = value;
      }
    }
  }
</script>
